import { render, staticRenderFns } from "./ContainerPesquisa.vue?vue&type=template&id=538eb5a7&scoped=true"
import script from "./ContainerPesquisa.vue?vue&type=script&lang=js"
export * from "./ContainerPesquisa.vue?vue&type=script&lang=js"
import style0 from "./ContainerPesquisa.vue?vue&type=style&index=0&id=538eb5a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538eb5a7",
  null
  
)

export default component.exports